import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Feedback } from './Feedback';

export const FeedbackPage = () => {
  useTitle('Обратная связь');

  return (
    <Layout withFooter>
      <Feedback />
    </Layout>
  );
};
